export default class Bang
{
  constructor(data = {}) {
    this.data = data;

    this.get = this.get.bind(this);
    this.has = this.has.bind(this);
  }

  get(key, defaultValue = null) {
    if (this.has(key)) {
      return this.data[key];
    }

    return defaultValue;
  }

  has(key) {
    return Object.hasOwnProperty.call(this.data, key);
  }

  first(key) {
    if (! this.has(key)) {
      return '';
    }

    const data = this.get(key, '');

    if (! Array.isArray(data)) return data;

    return data[0];
  }
}